import { useCallback } from 'react';

import qs from 'qs';

import { useSessionAsync } from 'src/app/shared/hooks/session';
import { isLoaded } from 'src/app/shared/utils/async';

import { usePetitionDetails } from '../../petitionDetails';
import { usePromotedTrackingDataWithQueryParams } from '../../promotions';

type Result = (options: { pathSuffix?: string; medium: string; additionalParams?: Record<string, string> }) => string;

export function useGenPetitionUrl(): Result {
	const session = useSessionAsync();
	const { slug } = usePetitionDetails();
	const promotedTrackingData = usePromotedTrackingDataWithQueryParams();

	const sessionUuid = isLoaded(session) ? session.value.uuid : undefined;
	const currentUserId = isLoaded(session) ? session.value.user?.id || undefined : undefined;
	const currentCampaign = isLoaded(session) ? session.value.trackingData.current_campaign || undefined : undefined;

	const promotionToken = promotedTrackingData?.token;

	return useCallback(
		({ pathSuffix, medium, additionalParams }) => {
			const trackParams = qs.stringify(
				{
					recruiter: currentUserId || undefined,
					recruited_by_id: sessionUuid,
					utm_source: 'share_petition',
					utm_campaign: 'share_petition',
					utm_term: currentCampaign,
					utm_medium: medium,
					pt: promotionToken,
					...additionalParams,
				},
				{ encodeValuesOnly: true },
			);
			return `/p/${slug}${pathSuffix || ''}?${trackParams}`;
		},
		[sessionUuid, currentUserId, slug, promotionToken, currentCampaign],
	);
}
